import React, {FC, useEffect} from 'react';
import * as serviceWorker from '../serviceWorker';

// if PWA is not updated and you need to force update, change this version number
export const SERVICE_WORKER_VERSION = 1;

const ServiceWorkerWrapper: FC = () => {


    const onSWUpdate = (registration: ServiceWorkerRegistration) => {

        console.log(registration);
        console.log(registration.waiting);
        console.log("***** NEED TO RELOAD SERVICE WORKER *****");
        registration.waiting?.postMessage({type: 'SKIP_WAITING'});
        window.location.reload();

    };

    useEffect(() => {
        console.log("register service worker");
        console.log("Current version " + SERVICE_WORKER_VERSION);
        serviceWorker.register({onUpdate: onSWUpdate});
    }, []);

    return <></>
}

export default ServiceWorkerWrapper;